/**
 * Created by Alex Xia on 11/20/2020.
 * Description:
 * ------ maintenance history ------
 * 03/29/2021 Alex Xia create DashboardMapAutocompleteBaseComponent to share some methods to map-autocomplete and map-trip-autocomplete
 */
import { Component, OnInit, ElementRef, OnDestroy, ViewChild, Input, ChangeDetectionStrategy, ChangeDetectorRef, Output, EventEmitter } from '@angular/core';
import { ContactService } from '@tamalelibs/services/contact.service';
import { DashboardTileService } from '../../../dashboard-tile.service';
import { AutocompleteActionType, MapContactModel } from '../../tam-dashboard-map-autocomplete/tam-dashboard-map-autocomplete.model';
import { MapTileService, TripAutocompleteActionType } from '@tamalelibs/services/maptile.service';
import { DashboardMapAutocompleteBaseComponent } from '../../tam-dashboard-map-autocomplete/dashboard-map-autocomplete.base';
import { MapTripActionType } from '../map-trip.model';
import { StoreQuerierService } from '../../../../../services/store-querier.service';

@Component({
    selector: 'tam-map-trip-autocomplete',
    templateUrl: './map-trip-autocomplete.component.html',
    styleUrls: ['./map-trip-autocomplete.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class TamDashboardMapTripAutocompleteComponent extends DashboardMapAutocompleteBaseComponent implements OnInit, OnDestroy {
    @Input() config: MapContactModel;
    @Output() eventSubject$ = new EventEmitter<any>();
    // static: true. Query results available in ngOnInit
    // static: false. Query results available in ngAfterViewInit
    @ViewChild('tripAutocomplete', { static: false }) tripAutocomplete: ElementRef;

    anchor: ElementRef;
    isCloseHidden = false;
    userInput = ''; // user search text
    currentPrediction: any;
    isShowNearby = false;
    /**
     * Use tags to indicate data sources
     */
    private _isFromDirectionInput = false;

    constructor(
        protected elementRef: ElementRef,
        protected mapTileService: MapTileService,
        protected _contactService: ContactService,
        protected _dashboardTileService?: DashboardTileService,
        protected _changeDetectorRef?: ChangeDetectorRef,
        protected _storeQuerier?: StoreQuerierService
    ) {
        super(_contactService, _dashboardTileService, _changeDetectorRef, _storeQuerier);
        this.element = this.elementRef.nativeElement;
    }

    ngOnInit() {
        if (this.config) {
            this.userInput = this.config.selectedAddress;
            this.currentPrediction = this.config;
            this._isFromDirectionInput = false;
        }
        this._initSubscriptions();
    }

    ngOnDestroy() {
        this.destroySubscriptions.forEach(subscription => subscription.unsubscribe());
        this.subscribed = false;
    }

    clickNearby() {
        this.eventSubject$.emit({ type: AutocompleteActionType.searchNearby, payload: this.currentPrediction, isTrip: true, isFromDirectionInput: this._isFromDirectionInput });
    }

    /*
     * trigger when user input value
     * need to include contacts in tamale and google predictions.
    */
    keyUpHandler() {
        this.isPopUpShow = false;
        if (this.userInput && this.userInput.length > 0 && this.currentPrediction && this.currentPrediction.contact) {
            this.currentPrediction.contact.name = '';
        }
        this._getAllPredicitons();
        this.mapTileService.tripAutoCompleteActionSubject$.next({
            type: TripAutocompleteActionType.ClearErrorMessage
        });
    }

    mouseLeave() {
        this.isShowNearby = false;
    }
    mouseEnter() {
        if (this.userInput) {
            this.isShowNearby = true;
        }
    }

    predictionSelected(suggestion: any) {
        // clear variables
        this.currentPrediction = suggestion;
        this.userInput = suggestion ? suggestion.selectedAddress : '';
        this.predictionArray = [];
        this._isFromDirectionInput = true;
    }

    showPopup(event: any) {
        this.anchor = event.target || event;
    }

    removeAutocomplete() {
        if (this.element) {
            const autocompleteToRemove = this.element.querySelector('.trip_autocomplete_container');
            if (this._getValidAutocompleteNumber(autocompleteToRemove.parentNode.parentNode.childNodes) > 2) {
                autocompleteToRemove.parentNode.removeChild(autocompleteToRemove);
                this.mapTileService.tripAutoCompleteActionSubject$.next({
                    type: TripAutocompleteActionType.RefreshTripMap
                });
            } else {
                // at least two controls(origin and destination) should be existed.
                this.mapTileService.tripAutoCompleteActionSubject$.next({
                    type: TripAutocompleteActionType.LessThanTwoAutocompletes
                });
            }
        }
    }

    /**
     * could not remove #tripAutoCompleteContainer element as it won't create autocomplete control after that
     * so we can only remove the childnode, the function is used to check if the childnodes have been removed
     * @param childNodes
     */
    private _getValidAutocompleteNumber(childNodes) {
        let num = 0;
        if (childNodes) {
            childNodes.forEach(node => {
                if (node.childNodes.length > 0) {
                    num++;
                }
            });
        }
        return num;
    }
}
